module.exports = __webpack_public_path__ + "static/img/banner.b5cc8086.jpg";